<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{
          $t('school.academic.operation.profile_mgt.teacher_profile.page_title')
        }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t(
              'school.academic.operation.profile_mgt.teacher_profile.page_title'
            ),
            href: '/teacher-profiles'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-loading-banner :loading="ready_fetch">
      <div class="row">
        <div class="col-md-4">
          <ts-card>
            <ts-card-wrapper>
              <div class="text-center">
                <ts-image-input
                  :file="file"
                  @input="file => (model.photo = file)"
                  :width="175"
                  :height="225"
                  crop
                ></ts-image-input>
                <span>
                  <i>
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.teacher_profile.teacher_photo'
                      )
                    }}
                  </i>
                </span>
                <div class="validate" v-if="errors.has('photo')">
                  {{ errors.first('photo') }}
                </div>
              </div>
              <div class="form-group">
                <ts-button color="info" outline @click="fromEmployee">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.teacher_profile.from_employee'
                    )
                  }}
                </ts-button>
              </div>
              <div class="form-group">
                <label class="required">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.teacher_profile.teacher_id'
                    )
                  }}
                </label>
                <div class="row">
                  <div class="col-md-12">
                    <input
                      type="text"
                      v-model.trim="model.teacher_code"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('teacher_code') }"
                      :placeholder="
                        $t(
                          'school.academic.operation.profile_mgt.teacher_profile.teacher_id'
                        )
                      "
                    />
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('teacher_code')"
                    >
                      {{ errors.first('teacher_code') }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="required">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.teacher_profile.name_en'
                    )
                  }}
                </label>
                <div class="row">
                  <div class="col-md-6">
                    <input
                      type="text"
                      ref="fname_foreign"
                      v-model.trim="model.fname_foreign"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('fname_foreign') }"
                      :placeholder="
                        $t(
                          'school.academic.operation.profile_mgt.teacher_profile.first_name_en'
                        )
                      "
                    />
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('fname_foreign')"
                    >
                      {{ errors.first('fname_foreign') }}
                    </div>
                  </div>
                  <div class="col-md-6">
                    <input
                      type="text"
                      v-model.trim="model.lname_foreign"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('lname_foreign') }"
                      :placeholder="
                        $t(
                          'school.academic.operation.profile_mgt.teacher_profile.last_name_en'
                        )
                      "
                    />
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('lname_foreign')"
                    >
                      {{ errors.first('lname_foreign') }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label>
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.teacher_profile.name_kh'
                    )
                  }}
                </label>
                <div class="row">
                  <div class="col-md-6">
                    <input
                      type="text"
                      v-model.trim="model.fname_native"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('fname_native') }"
                      :placeholder="
                        $t(
                          'school.academic.operation.profile_mgt.teacher_profile.first_name_kh'
                        )
                      "
                    />
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('fname_native')"
                    >
                      {{ errors.first('fname_native') }}
                    </div>
                  </div>
                  <div class="col-md-6">
                    <input
                      type="text"
                      v-model.trim="model.lname_native"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('lname_native') }"
                      :placeholder="
                        $t(
                          'school.academic.operation.profile_mgt.teacher_profile.last_name_kh'
                        )
                      "
                    />
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('lname_native')"
                    >
                      {{ errors.first('lname_native') }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="radio radio-css radio-inline">
                  <input
                    type="radio"
                    id="male"
                    v-model.number="model.gender"
                    value="1"
                  />
                  <label for="male">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.teacher_profile.male'
                      )
                    }}
                  </label>
                </div>
                <div class="radio radio-css radio-inline">
                  <input
                    type="radio"
                    id="female"
                    v-model.number="model.gender"
                    value="2"
                  />
                  <label for="female">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.teacher_profile.female'
                      )
                    }}
                  </label>
                </div>
                <div class="text-danger" v-if="errors.has('gender')">
                  {{ errors.first('gender') }}
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 row ts-pt-4">
                  <label class="col-md-6 col-form-label">{{
                    $t('signature.signatureFile')
                  }}</label>
                  <div class="col-md-6">
                    <ts-button color="primary" @click="$refs.file.click()">{{
                      $t('signature.browseFile')
                    }}</ts-button>
                    <input
                      type="file"
                      ref="file"
                      style="display: none"
                      accept="image/x-png, image/gif, image/jpeg"
                      @change="onFileChange"
                    />
                    <div class="text-danger" v-if="errors.has('file')">
                      {{ errors.first('file') }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <img id="signature" :src="priview" alt />
                </div>
              </div>
            </ts-card-wrapper>
          </ts-card>
        </div>
        <div class="col-md-8">
          <ts-card>
            <ts-card-wrapper>
              <form class="form-horizontal">
                <h1 class="section-divider-override">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.teacher_profile.more_details'
                    )
                  }}
                </h1>
                <div class="row">
                  <div class="col-md-6">
                    <div class="row form-group">
                      <label class="col-md-4 col-form-label required">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.teacher_profile.position'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        <select
                          v-model.number="model.position_id"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('position_id') }"
                        >
                          <option
                            v-if="model.position_id === null"
                            :value="null"
                            disabled
                            selected
                            style="display: none"
                          >
                            {{ $t('select') }}
                          </option>
                          <option
                            v-else
                            value
                            disabled
                            selected
                            style="display: none"
                          >
                            {{ $t('select') }}
                          </option>
                          <option
                            v-for="(position, index) in positions"
                            :key="index"
                            :value="position.position_id"
                          >
                            {{ position.pos_name_en }}
                          </option>
                        </select>
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('position_id')"
                        >
                          {{ errors.first('position_id') }}
                        </div>
                      </div>
                    </div>

                    <div class="row form-group">
                      <label class="col-md-4 col-form-label required">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.teacher_profile.register_type'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        <select
                          v-model.number="model.reg_type_id"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('reg_type_id') }"
                        >
                          <option value>{{ $t('select') }}</option>
                          <option
                            v-for="(activate_type, index) in activate_types"
                            :key="index"
                            :value="activate_type.reg_type_id"
                          >
                            {{ activate_type.reg_type }}
                          </option>
                        </select>
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('reg_type_id')"
                        >
                          {{ errors.first('reg_type_id') }}
                        </div>
                      </div>
                    </div>

                    <div class="row form-group">
                      <label class="col-md-4 col-form-label">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.teacher_profile.date_of_birth'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        <ts-date-picker-input
                          v-model="model.dob"
                        ></ts-date-picker-input>
                        <div class="validate" v-if="errors.has('dob')">
                          {{ errors.first('dob') }}
                        </div>
                      </div>
                    </div>

                    <div class="row form-group">
                      <label class="col-md-4 col-form-label">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.teacher_profile.nationality'
                          )
                        }}
                        <i class="fas fa-spinner spin" v-if="ready_fetch"></i>
                      </label>
                      <div class="col-md-7">
                        <ts-search-select
                          v-model="model.na_id"
                          :options="nationalities"
                          :disabled="ready_fetch"
                        ></ts-search-select>
                      </div>
                    </div>

                    <div class="row form-group">
                      <label class="col-md-4 col-form-label">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.teacher_profile.passport_no'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        <input
                          v-model="model.id_card_no"
                          type="number"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('id_card_no') }"
                        />
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('id_card_no')"
                        >
                          {{ errors.first('id_card_no') }}
                        </div>
                      </div>
                    </div>

                    <div class="row form-group">
                      <label class="col-md-4 col-form-label required">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.teacher_profile.phone'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        <input
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('phone') }"
                          v-model="model.phone"
                        />
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('phone')"
                        >
                          {{ errors.first('phone') }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row form-group">
                      <label class="col-md-4 col-form-label required">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.teacher_profile.teacher_type'
                          )
                        }}
                        <i class="fas fa-spinner spin" v-if="ready_fetch"></i>
                      </label>
                      <div class="col-md-7">
                        <select
                          class="form-control"
                          :class="{
                            'is-invalid': errors.has('teacher_pos_id')
                          }"
                          v-model.number="model.teacher_pos_id"
                        >
                          <option value>{{ $t('select') }}</option>
                          <option value="1">
                            {{ $t('teacherprofile.teacher') }}
                          </option>
                          <option value="2">
                            {{ $t('teacherprofile.teacherAssistant') }}
                          </option>
                        </select>
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('teacher_pos_id')"
                        >
                          {{ errors.first('teacher_pos_id') }}
                        </div>
                      </div>
                    </div>

                    <div class="row form-group">
                      <label class="col-md-4 col-form-label required">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.teacher_profile.shift_name'
                          )
                        }}
                        <i class="fas fa-spinner spin" v-if="ready_fetch"></i>
                      </label>
                      <div class="col-md-7">
                        <select
                          v-model.number="model.shift_id"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('shift_id') }"
                          :disabled="ready_fetch"
                        >
                          <option
                            v-if="model.shift_id === null"
                            :value="null"
                            disabled
                            selected
                            style="display: none"
                          >
                            {{ $t('select') }}
                          </option>
                          <option
                            v-else
                            value
                            disabled
                            selected
                            style="display: none"
                          >
                            {{ $t('select') }}
                          </option>
                          <option
                            v-for="(shift, index) in shifts"
                            :key="index"
                            :value="shift.shift_id"
                          >
                            {{ shift.shift_name }} ({{ shift.shift_type }})
                          </option>
                        </select>
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('shift_id')"
                        >
                          {{ errors.first('shift_id') }}
                        </div>
                      </div>
                    </div>

                    <div class="row form-group">
                      <label class="col-md-4 col-form-label">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.teacher_profile.place_of_birth'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        <textarea
                          v-model="model.pob"
                          class="form-control"
                          rows="1"
                          :class="{ 'is-invalid': errors.has('pob') }"
                        ></textarea>
                        <div class="invalid-feedback" v-if="errors.has('pob')">
                          {{ errors.first('pob') }}
                        </div>
                      </div>
                    </div>

                    <div class="row form-group">
                      <label class="col-md-4 col-form-label">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.teacher_profile.status'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        <select
                          v-model.number="model.teacher_status"
                          class="form-control"
                          :class="{
                            'is-invalid': errors.has('teacher_status')
                          }"
                        >
                          <option value>{{ $t('select') }}</option>
                          <option value="1">Single</option>
                          <option value="2">Married</option>
                        </select>
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('teacher_status')"
                        >
                          {{ errors.first('teacher_status') }}
                        </div>
                      </div>
                    </div>

                    <div class="row form-group">
                      <label class="col-md-4 col-form-label">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.teacher_profile.education_level'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        <input
                          v-model="model.education_level"
                          type="text"
                          class="form-control"
                          :class="{
                            'is-invalid': errors.has('education_level')
                          }"
                        />
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('education_level')"
                        >
                          {{ errors.first('education_level') }}
                        </div>
                      </div>
                    </div>

                    <div class="row form-group">
                      <label class="col-md-4 col-form-label">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.teacher_profile.email'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        <input
                          type="email"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('email') }"
                          v-model.number="model.email"
                        />
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('email')"
                        >
                          {{ errors.first('email') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <br />
                <h1 class="section-divider-override">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.teacher_profile.address'
                    )
                  }}
                </h1>
                <div class="row ts-mb-20">
                  <div class="col-md-6">
                    <div class="row form-group">
                      <label class="col-md-4 col-form-label">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.teacher_profile.country'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        <select
                          class="form-control"
                          v-model.number="model.country_id"
                        >
                          <option value>{{ $t('select') }}</option>
                          <option value="1">
                            {{ $t('teacherprofile.cambodia') }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="row form-group">
                      <label class="col-md-4 col-form-label">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.teacher_profile.province'
                          )
                        }}
                        <i class="fas fa-spinner spin" v-if="ready_fetch"></i>
                      </label>
                      <div class="col-md-7">
                        <select
                          class="form-control"
                          :disabled="ready_fetch"
                          v-model.number="model.province_code"
                          @change="onProvinceChange"
                        >
                          <option value>{{ $t('select') }}</option>
                          <option
                            v-for="(province, index) in provinces"
                            :key="index"
                            :value="province.province_code"
                          >
                            {{ province.province_name }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="row form-group">
                      <label class="col-md-4 col-form-label">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.teacher_profile.district'
                          )
                        }}
                        <i
                          class="fas fa-spinner spin"
                          v-if="district_fetch"
                        ></i>
                      </label>
                      <div class="col-md-7">
                        <select
                          v-model.number="model.district_code"
                          :disabled="!districts.length > 0"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('district_code') }"
                          @change="onDistrictChange"
                        >
                          <option value>{{ $t('select') }}</option>
                          <option
                            v-for="(district, index) in districts"
                            :key="index"
                            :value="district.district_code"
                          >
                            {{ district.district_name }}
                          </option>
                        </select>
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('district_code')"
                        >
                          {{ errors.first('district_code') }}
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <label class="col-md-4 col-form-label">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.teacher_profile.commune'
                          )
                        }}
                        <i class="fas fa-spinner spin" v-if="commune_fetch"></i>
                      </label>
                      <div class="col-md-7">
                        <select
                          v-model="model.commune_code"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('commune_code') }"
                          :disabled="!communes.length > 0"
                          @change="onCommuneChange"
                        >
                          <option value>{{ $t('select') }}</option>
                          <option
                            v-for="(commune, index) in communes"
                            :key="index"
                            :value="commune.commune_code"
                          >
                            {{ commune.commune_name }}
                          </option>
                        </select>
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('commune_code')"
                        >
                          {{ errors.first('commune_code') }}
                        </div>
                      </div>
                    </div>
                    <br />
                    <div clas="row form-group">
                      <div class="col-md-12">
                        <ts-checkbox
                          v-model="model.is_appear_other_company"
                          >{{
                            $t(
                              'school.academic.operation.profile_mgt.teacher_profile.isAppearOtherCompany'
                            )
                          }}</ts-checkbox
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row form-group">
                      <label class="col-md-4 col-form-label">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.teacher_profile.village'
                          )
                        }}
                        <i class="fas fa-spinner spin" v-if="village_fetch"></i>
                      </label>
                      <div class="col-md-7">
                        <select
                          v-model="model.village_code"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('village_code') }"
                          :disabled="!villages.length > 0"
                        >
                          <option value>{{ $t('select') }}</option>
                          <option
                            v-for="(village, index) in villages"
                            :key="index"
                            :value="village.village_code"
                          >
                            {{ village.village_name }}
                          </option>
                        </select>
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('village_code')"
                        >
                          {{ errors.first('village_code') }}
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-form-label">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.teacher_profile.street'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        <input
                          type="text"
                          v-model="model.street"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('street') }"
                        />
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('street')"
                        >
                          {{ errors.first('street') }}
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-form-label">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.teacher_profile.house'
                          )
                        }}
                      </label>
                      <div class="col-md-7">
                        <input
                          type="text"
                          v-model="model.house"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('house') }"
                        />
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('house')"
                        >
                          {{ errors.first('house') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </ts-card-wrapper>
          </ts-card>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-12">
          <div class="form-group">
            <ts-card>
              <ts-card-wrapper>
                <h1 class="section-divider">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.teacher_profile.subjects'
                    )
                  }}
                </h1>
                <subject-list
                  v-model="model.teacher_subject_list"
                  :validate="errors"
                  :is_appear_other_company="model.is_appear_other_company"
                />
                <h1 class="section-divider">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.teacher_profile.experiences'
                    )
                  }}
                </h1>
                <experience-list
                  v-model="model.teacher_experience_list"
                  :validate="errors"
                />
                <h1 class="section-divider">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.teacher_profile.skill'
                    )
                  }}
                </h1>
                <skill v-model="model.teacher_skill_list" :validate="errors" />
                <div class="row">
                  <div class="col-md-12 text-right">
                    <ts-button
                      @click="$router.push({ name: 'teacher-profile' })"
                      >{{ $t('cancel') }}</ts-button
                    >
                    <ts-button
                      outline
                      color="primary"
                      class="ml-2"
                      :waiting="waiting_save_new"
                      @click.prevent="saveAddNew"
                      >{{ $t('save_add_new') }}</ts-button
                    >
                    <ts-button
                      color="primary"
                      class="ml-2"
                      :waiting="waiting_save"
                      @click.prevent="store"
                      >{{ $t('save') }}</ts-button
                    >
                  </div>
                </div>
              </ts-card-wrapper>
            </ts-card>
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
import subjectList from './subject'
import experienceList from './experience'
import skill from './skill'
import FromEmployee from './from-employee'
import Compressor from 'compressorjs'

export default {
  name: 'teacher-profile-create',
  components: {
    subjectList,
    experienceList,
    skill
  },
  data () {
    return {
      model: {
        is_appear_other_company: false,
        teacher_code: '',
        fname_native: '',
        lname_native: '',
        fname_foreign: '',
        lname_foreign: '',
        gender: 1,
        id_card_no: '',
        education_level: '',
        na_id: '',
        dob: '',
        pob: '',
        phone: '',
        email: '',
        house: '',
        street: '',
        village_code: '',
        commune_code: '',
        district_code: '',
        province_code: '',
        country_id: 1,
        teacher_status: '',
        photo: '',
        teacher_subject_list: [],
        teacher_experience_list: [],
        teacher_skill_list: [],
        reg_type_id: 3,
        teacher_pos_id: '',
        position_id: '',
        shift_id: '',
        ref_staff_id: '',
        signatures: '',
        file: '',
        acp_id: ''
      },
      errors: new Errors(),
      file: require('../../assets/user_default.png'),
      priview:
        'https://cdn.pixabay.com/photo/2012/04/11/11/16/signature-27485_960_720.png',
      ready_fetch: false,
      district_fetch: false,
      commune_fetch: false,
      village_fetch: false,
      districts: [],
      communes: [],
      villages: [],
      waiting_save: false,
      waiting_save_new: false,
      loading: false
    }
  },
  async created () {
    this.ready_fetch = true
    await this.dataBeforeCreate()
    this.fromEmployee()
    this.$refs.fname_foreign.focus()
    this.ready_fetch = false
  },
  computed: {
    ...mapState('teacherProfile', [
      'activate_types',
      'main_programs',
      'provinces',
      'shifts',
      'positions'
    ]),
    nationalities () {
      return this.$store.state.teacherProfile.nationalities.map(el => ({
        text: el.nationality,
        value: el.id
      }))
    }
  },
  methods: {
    ...mapActions('teacherProfile', ['dataBeforeCreate']),
    onFileChange (e) {
      let file = e.target.files[0]
      if (file instanceof File || file instanceof Blob) {
        this.model.file = file
      }

      let reader = new FileReader()
      reader.addEventListener(
        'load',
        function () {
          this.priview = reader.result
        }.bind(this),
        false
      )
      if (file) {
        if (/\.(jpe?g|png)$/i.test(file.name)) {
          reader.readAsDataURL(file)
        }
      }
    },
    async signaturesUpload () {
      if (this.model.file instanceof File || this.model.file instanceof Blob) {
        let formData = new FormData()
        formData.append('signatures', this.model.file)
        let response = await this.$store.dispatch(
          'teacherProfile/uploadSignatures',
          formData
        )
        this.model.signatures = response
      }
      return ''
    },
    async onProvinceChange () {
      this.clearValueBaseOnProvine()
      this.district_fetch = true
      await this.$store
        .dispatch('teacherProfile/district', this.model.province_code)
        .then(response => {
          this.district_fetch = false
          this.districts = response.data
        })
        .catch(error => {
          this.district_fetch = false
          this.$toasted.error(error.message)
        })
    },
    async onDistrictChange () {
      this.model.commune_code = ''
      this.commune_fetch = true
      await this.$store
        .dispatch('teacherProfile/commune', this.model.district_code)
        .then(response => {
          this.commune_fetch = false
          this.communes = response.data
        })
        .catch(error => {
          this.commune_fetch = false
          this.$toasted.error(error.message)
        })
    },
    async onCommuneChange () {
      this.model.village_code = ''
      this.village_fetch = true
      await this.$store
        .dispatch('teacherProfile/village', this.model.commune_code)
        .then(response => {
          this.village_fetch = false
          this.villages = response.data
        })
        .catch(error => {
          this.village_fetch = false
          this.$toasted.error(error.message)
        })
    },
    async store () {
      this.waiting_save = true
      this.errors = new Errors()
      if (
        this.model.photo instanceof File ||
        this.model.photo instanceof Blob
      ) {
        new Compressor(this.model.photo, {
          quality: 0.1,
          success: async result => {
            let formData = new FormData()
            formData.append('photo', result)
            let photo_path = await this.$store.dispatch(
              'teacherProfile/uploadPhoto',
              formData
            )
            await this.signaturesUpload()
            await this.$store
              .dispatch(
                'teacherProfile/store',
                Object.assign({}, this.model, { photo: photo_path })
              )
              .then(response => {
                this.waiting_save = false
                this.$toasted.success(response.message)
                this.$router.push({ name: 'teacher-profile' })
              })
              .catch(error => {
                this.waiting_save = false
                this.$toasted.error(error.message)
                this.errors = new Errors(error.errors)
              })
          }
        })
      } else {
        await this.signaturesUpload()
        this.$store
          .dispatch(
            'teacherProfile/store',
            Object.assign({}, this.model, { photo: this.model.photo })
          )
          .then(response => {
            this.waiting_save = false
            this.$toasted.success(response.message)
            this.$router.push({ name: 'teacher-profile' })
          })
          .catch(error => {
            this.waiting_save = false
            this.$toasted.error(error.message)
            this.errors = new Errors(error.errors)
          })
      }
    },
    async onMainProgramChange (subject) {
      if (!subject.acp_id) {
        subject.acps_id = ''
        subject.subject_id = ''
        return
      }
      await this.$store
        .dispatch('teacherProfile/subProgram', subject.acp_id)
        .then(response => {})
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    async saveAddNew () {
      this.errors = new Errors()
      this.waiting_save_new = true
      if (
        this.model.photo instanceof File ||
        this.model.photo instanceof Blob
      ) {
        new Compressor(this.model.photo, {
          quality: 0.1,
          success: async result => {
            let formData = new FormData()
            formData.append('photo', result)
            let photo_path = await this.$store.dispatch(
              'teacherProfile/uploadPhoto',
              formData
            )
            await this.signaturesUpload()
            await this.$store
              .dispatch(
                'teacherProfile/store',
                Object.assign({}, this.model, { photo: photo_path })
              )
              .then(response => {
                this.waiting_save_new = false
                this.$toasted.success(response.message)
                this.clearInput()
              })
              .catch(error => {
                this.waiting_save_new = false
                this.$toasted.error(error.message)
                this.errors = new Errors(error.errors)
              })
          }
        })
      } else {
        await this.signaturesUpload()
        this.$store
          .dispatch(
            'teacherProfile/store',
            Object.assign({}, this.model, { photo: this.model.photo })
          )
          .then(response => {
            this.waiting_save_new = false
            this.$toasted.success(response.message)
            this.clearInput()
          })
          .catch(error => {
            this.waiting_save_new = false
            this.$toasted.error(error.message)
            this.errors = new Errors(error.errors)
          })
      }
    },
    clearValueBaseOnProvine () {
      this.model.district_code = ''
      this.districts = []
      this.model.commune_code = ''
      this.communes = []
      this.model.village_code = ''
      this.villages = []
    },
    clearInput () {
      this.errors = new Errors()
      ;(this.file = ''),
        (this.model.is_appear_other_company = false),
        (this.model.teacher_code = '')
      this.model.fname_native = ''
      this.model.lname_native = ''
      this.model.fname_foreign = ''
      this.model.lname_foreign = ''
      this.model.gender = 1
      this.model.id_card_no = ''
      this.model.education_level = ''
      this.model.na_id = ''
      this.model.dob = ''
      this.model.pob = ''
      this.model.phone = ''
      this.model.email = ''
      this.model.house = ''
      this.model.street = ''
      this.model.village_code = ''
      this.model.commune_code = ''
      this.model.district_code = ''
      this.model.province_code = ''
      this.model.country_id = 1
      this.model.teacher_status = ''
      this.model.photo = ''
      this.model.teacher_subject_list = []
      this.model.teacher_experience_list = []
      this.model.teacher_skill_list = []
      this.model.reg_type_id = ''
      this.model.teacher_pos_id = ''
      this.model.position_id = ''
      this.model.ref_staff_id = ''
      this.model.shift_id = ''
      this.model.acp_id = '',

      this.priview =
        'https://cdn.pixabay.com/photo/2012/04/11/11/16/signature-27485_960_720.png'
      this.signatures = ''
    },
    fromEmployee () {
      this.$modal.show(
        FromEmployee,
        { value: this.model },
        {
          height: 'auto',
          width: '55%',
          scrollable: true,
          clickToClose: false
        },
        {
          'before-close': () => {
            if (!this.model.ref_staff_id) {
              this.$router.push({ name: 'teacher-profile' })
            }
          }
        }
      )
    }
  },
  watch: {
    'model.photo': function (value) {
      if (value) {
        this.file = value
      }
    },
    'model.province_code': function (value) {
      if (value) {
        this.onProvinceChange()
      }
    },
    'model.district_code': function (value) {
      if (value) {
        this.onDistrictChange()
      }
    },
    'model.commune_code': function (value) {
      if (value) {
        this.onCommuneChange()
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('teacherProfile/RESET_STATE')
    }
    next()
  }
}
</script>

<style lang="css" scoped>
.section-divider-override {
  border-bottom: 1px solid rgb(239, 239, 239);
  margin-bottom: 2.1rem;
  font-size: 1rem;
  padding-bottom: 0.3rem;
  color: #929090;
}
.file-input-container {
  width: 174px !important;
  margin: 0 auto;
  border: 1px solid #eaeaea;
  padding: 4px;
  border-radius: 5px;
}
#signature {
  height: 100px;
  margin: 16px 0;
}
</style>
